export const SECTIONS = [
  {
    id: "personal",
    title: "Personal Stability",
    subtitle: "Your emotional, physical, and lifestyle foundation.",
    weight: "35%",
    questions: [
      { id: "p_stress", text: "How would you rate your current stress level?", low: "Very high stress", high: "Very calm", reverse: true },
      { id: "p_routines", text: "How consistent are your daily routines (sleep, diet, structure)?", low: "Chaotic", high: "Highly consistent" },
      { id: "p_clarity", text: "How mentally clear do you feel when making important decisions?", low: "Foggy", high: "Crystal clear" },
      { id: "p_resilience", text: "How confident are you in handling unexpected challenges?", low: "Not confident", high: "Very confident" },
      { id: "p_support", text: "How strong is your personal support system (family, friends, mentors)?", low: "Very weak", high: "Very strong" },
      { id: "p_overwhelmed", text: "How often do you feel overwhelmed by your responsibilities?", low: "Constantly", high: "Rarely", reverse: true },
      { id: "p_energy", text: "How would you rate your overall physical energy and health?", low: "Depleted", high: "Excellent" },
      { id: "p_time", text: "How much time flexibility do you have weekly for new opportunities?", low: "None", high: "Plenty" },
    ],
  },
  {
    id: "professional",
    title: "Professional Momentum",
    subtitle: "Your trajectory, earning potential, and career leverage.",
    weight: "35%",
    questions: [
      { id: "w_stability", text: "How stable is your current employment / income source?", low: "Very unstable", high: "Very stable" },
      { id: "w_satisfaction", text: "How satisfied are you with your current career direction?", low: "Unsatisfied", high: "Very satisfied" },
      { id: "w_skills", text: "How aligned are your current skills with your long-term goals?", low: "Misaligned", high: "Fully aligned" },
      { id: "w_income_growth", text: "How confident are you in increasing your income in the next 12 months?", low: "Not confident", high: "Very confident" },
      { id: "w_network", text: "How strong is your professional network?", low: "Very weak", high: "Very strong" },
      { id: "w_opportunities", text: "How often are you presented with new opportunities?", low: "Never", high: "Frequently" },
      { id: "w_momentum", text: "How would you rate your current career growth momentum?", low: "Stalled", high: "Accelerating" },
    ],
  },
  {
    id: "financial",
    title: "Financial Health",
    subtitle: "Your risk capacity and financial resilience.",
    weight: "30%",
    questions: [
      { id: "f_obligations", text: "How confident are you in meeting monthly financial obligations?", low: "Not confident", high: "Very confident" },
      {
        id: "f_savings",
        text: "Approximately how many months of expenses do you have saved?",
        type: "choice",
        options: [
          { label: "0–1 months", value: 0 },
          { label: "2–3 months", value: 1 },
          { label: "4–6 months", value: 2 },
          { label: "6–12 months", value: 3 },
          { label: "12+ months", value: 4 },
        ],
      },
      { id: "f_debt", text: "How manageable is your current debt level?", low: "Overwhelming", high: "Very manageable" },
      { id: "f_consistency", text: "How consistent is your income month-to-month?", low: "Erratic", high: "Very steady" },
      { id: "f_discipline", text: "How disciplined are your spending habits?", low: "Undisciplined", high: "Very disciplined" },
      { id: "f_unexpected", text: "How prepared are you for a major unexpected expense?", low: "Not prepared", high: "Fully prepared" },
      { id: "f_risk", text: "How comfortable are you taking financial risks?", low: "Very uncomfortable", high: "Very comfortable" },
    ],
  },
];

export const DECISIONS = [
  { value: "career_change", label: "Career Change" },
  { value: "start_business", label: "Start a Business" },
  { value: "real_estate", label: "Real Estate Purchase" },
  { value: "relocation", label: "Relocation" },
  { value: "education", label: "Education" },
  { value: "relationship", label: "Relationship / Family" },
  { value: "other", label: "Other" },
];

export const TIMELINES = [
  { value: "immediate", label: "Immediate (0–30 days)" },
  { value: "short", label: "Short-term (1–3 months)" },
  { value: "mid", label: "Mid-term (3–12 months)" },
];

export const ALL_QUESTION_IDS = SECTIONS.flatMap((s) => s.questions.map((q) => q.id));
